import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useKeycloak } from "@/auth/KeycloakAuthState.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";

export type SecurityProps = {
  className?: string;
};

export const Security: React.FC<SecurityProps> = ({ className }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);
  const keycloak = useKeycloak(state => state.keycloak);

  return (
    <Card id="security-card" className={className}>
      <CardHeader id="security-title" title={t("pages.account.security.title")} />
      <CardContent>
        <Button
          id="update-password-button"
          data-action="auth.password.update"
          className={styles.button}
          variant="outlined"
          onClick={() => keycloak.login({ action: "UPDATE_PASSWORD" })}
        >
          {t("pages.account.security.updatePassword")}
        </Button>
      </CardContent>
    </Card>
  );
};

const makeStyles = () => ({
  button: css`
    width: fit-content;
  `,
});
